import { Link } from "react-router-dom";

export const CLIENT_LOGOS = [
  { src: "/assets/clients/dmart.jpeg", alt: "DMart" },
  { src: "/assets/clients/exponent.jpeg", alt: "Exponent Energy" },
  { src: "/assets/clients/happiest-minds.jpeg", alt: "Happiest Minds" },
  { src: "/assets/clients/mitsubishi.jpeg", alt: "Mitsubishi Hitachi" },
  { src: "/assets/clients/sai.webp", alt: "Sai Life Sciences" },
  { src: "/assets/clients/bharat-petroleum.png", alt: "Bharat Petroleum" },
  { src: "/assets/clients/wipro.png", alt: "Wipro" },
  { src: "/assets/clients/sundaram-motors.png", alt: "Sundaram Motors" },
  { src: "/assets/clients/emmvee.png", alt: "EMMVEE" },
  { src: "/assets/clients/syngene.jpg", alt: "Syngene" },
];

export function ClientMarquee() {
  const loop = [...CLIENT_LOGOS, ...CLIENT_LOGOS];
  return (
    <section className="client-strip" aria-label="Clients" data-testid="client-marquee">
      <p className="client-label">Trusted by leading organisations</p>
      <div className="marquee">
        <div className="marquee-track">
          {loop.map((c, i) => (
            <span key={i}>
              <img src={c.src} alt={c.alt} loading="lazy" />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}

export function HeroBg() {
  return (
    <div className="hero-bg" aria-hidden="true">
      <div className="hero-grid" />
      <div className="hero-nodes">
        <span /><span /><span />
      </div>
    </div>
  );
}

export function PageHero({ crumb, title, children }) {
  return (
    <section className="page-hero" data-testid="page-hero">
      <HeroBg />
      <div className="section-inner page-hero-inner">
        <p className="crumb">
          <Link to="/">Home</Link> &nbsp;/&nbsp; {crumb}
        </p>
        <h1>{title}</h1>
        {children && <p>{children}</p>}
      </div>
    </section>
  );
}
